import React from "react";

const TeamContext = React.createContext();

export default TeamContext;
